import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import LessonSimpleReadOnlyIsland from "react-app/islands/LessonSimpleReadOnlyIsland"

interface Signature {
  Args: {
    lesson: CardStack
    lessonTitleClass?: string
    showOddMessageIfCardsAreNull?: boolean
    /**
     * Flag to tweak reactivity when we're passed a version of a lesson
     * instead of an actual lesson.
     * Needed for React.
     */
    isVersion?: boolean
  }
}

export default class LessonSimpleReadOnlyIslandBridge extends Component<Signature> {
  readonly LessonSimpleReadOnlyIsland = LessonSimpleReadOnlyIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::LessonSimpleReadOnlyIslandBridge": typeof LessonSimpleReadOnlyIslandBridge
  }
}
